<ui-mobile-navigation
  (categoryChanged)="onCategoryChange($event)"
  [currentCategoryId]="currentCategoryId()"
  view="offers">
</ui-mobile-navigation>
